import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import type { CustodyCase } from '../../types/case';
import { processSteps } from '../../utils/caseStatus';
import { bn } from '../../utils/bn';
export function ProcessTracker({
  c,
  compact = false
}: {
  c: CustodyCase;
  compact?: boolean;
}) {
  const steps = processSteps(c);
  return <ol className="flex items-start w-full" aria-label="প্রক্রিয়ার অগ্রগতি" data-id="element-779" data-mp="1lasee76pcccm">
      {steps.map((s, i) => {
      const dot = s.state === 'done' ? 'bg-success text-white border-success' : s.state === 'current' ? 'bg-white text-navy border-navy ring-4 ring-navy-50' : s.state === 'issue' ? 'bg-danger text-white border-danger' : 'bg-white text-ink-soft border-line';
      const lineDone = s.state === 'done';
      return <li key={s.label} className="flex-1 flex flex-col items-center relative min-w-0" data-id="element-780" data-mp="290d0gyy5jpq4" data-mpi={i}>
            {i < steps.length - 1 && <span className={`absolute top-3.5 left-1/2 w-full h-0.5 ${lineDone ? 'bg-success' : 'bg-line'}`} aria-hidden data-id="element-781" data-mp="2cykfnpcywiz7" />}
            <span className={`relative z-10 flex items-center justify-center rounded-full border-2 font-bold ${compact ? 'h-7 w-7 text-[11px]' : 'h-7 w-7 text-xs'} ${dot}`} data-id="element-782" data-mp="j9lvrr6zoflo">
              {s.state === 'done' ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-783" data-mp="9ch7nltl2a28" /> : s.state === 'issue' ? <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-784" data-mp="16zq0k1vwyle9" /> : bn(i + 1)}
            </span>
            <span className={`mt-1.5 text-center leading-tight px-0.5 ${compact ? 'text-[10px]' : 'text-xs'} ${s.state === 'pending' ? 'text-ink-soft' : 'text-ink font-semibold'}`} data-id="element-785" data-mp="171kaym9k6v43">
              {s.label}
            </span>
          </li>;
    })}
    </ol>;
}